module.exports = __webpack_public_path__ + "static/media/videoLetter.00c39ee8.png";